import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
//components
import AuthMain from "../AuthMain";
import { Input } from "components/shared/Input";

//Utils
import { cellNumberValidation, emailValidation } from "utils/phoneNumber";
//import { isPersian } from "utils/tools";

//Request
import { request } from "utils/request";

//Context
import { UserContext } from "state/user/userContext";
import { GlobalContext } from "state/global/globalContext";


const Login = () => {
    //state
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [cellphone, setCellphone] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    //const
    const history = useHistory();
    // const isPersianchar = isPersian(firstName);
    // console.log(isPersianchar);

    //use context
    const { dispatch } = useContext(UserContext);
    const { setErrorRecived, setLoading } = useContext(GlobalContext);

    // Validation
    const cellphoneValidation = cellphone.length === 11 ? cellNumberValidation(cellphone) : false;
    const emailValid = emailValidation(email);

    const requestRegister = () => {
        const formValid = firstName.length && lastName.length && cellphoneValidation && emailValid && password.length;

        if (!!formValid) {
            setLoading(true);
            request
                .post(
                    "/api/users/register.json",
                    JSON.stringify({
                        firstName,
                        lastName,
                        mobile: cellphone,
                        email,
                        password,
                    }),
                )
                .then((res) => {
                    setLoading(false);
                    if (res?.data.state) {
                        dispatch({
                            type: "setPhoneNumber",
                            payload: cellphone,
                        });
                        history.push("/otp");
                    } else {
                        setErrorRecived(res?.data.message);
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    setErrorRecived("لطفا چند لحظه دیگر مجدد تلاش کنید");
                });
        } else {
            setError(true);
        }
    };

    return (
        <AuthMain
            title="ایجاد حساب کاربری"
            buttonText="ایجاد حساب کاربری"
            onClickButton={requestRegister}
            register={true}
        >
            <Input
                type="text"
                placeholder="نام"
                icon="icon-avatar"
                onInput={(e) => setFirstName(e.target.value)}
                error={error && !firstName.length && "نام خود را وارد کنید"}
                Lang="fa-IR"
            />

            <Input
                type="text"
                placeholder="نام خانوادگی"
                onInput={(e) => setLastName(e.target.value)}
                icon="icon-avatar"
                error={error && !lastName.length && "نام خانوادگی خود را وارد کنید"}
                Lang="fa-IR"
            />

            <Input
                type="text"
                placeholder="شماره همراه"
                onInput={(e) => setCellphone(e.target.value)}
                maxLength="11"
                align="left"
                icon="icon-smartphone"
                error={
                    error && !cellphone.length
                        ? "شماره همراه خود را وارد کنید"
                        : error && !cellphoneValidation && "شماره همراه خود را به صورت صحیح وارد کنید"
                }
            />

            <Input
                type="text"
                placeholder="ایمیل"
                onInput={(e) => setEmail(e.target.value)}
                align="left"
                icon="icon-envelope"
                error={
                    error && !email.length
                        ? "ایمیل خود را وارد کنید"
                        : error && !emailValid && "ایمیل خود خود را به صورت صحیح وارد کنید"
                }
            />

            <Input
                type="password"
                placeholder="رمز عبور"
                icon="icon-locked"
                align="left"
                onInput={(e) => setPassword(e.target.value)}
                error={error && !password.length && "رمز عبور خود را وارد کنید"}
            />
        </AuthMain>
    );
};
export default Login;
